import {Component, OnChanges, OnInit, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';

@Component({
  selector: 'luci-accordion-panel',
  templateUrl: './luci-accordion-panel.component.html',
  styleUrls: ['./luci-accordion-panel.component.scss']
})
export class LuciAccordionPanelComponent implements OnInit, OnChanges {

  @Input() opened = false;
  @Input() title: string;
  @Input() disabled: false;
  @Output() toggle: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && changes.disabled.currentValue === true) {
      if (this.opened) {
        this.toggle.emit();
      }
    }
  }
}
